/**
 * Configuration constants for the TV guide timeline view
 */
export const timelineConfig = {
    /**
     * Width per second (320px = 60 minutes, so 320 / 60 / 60)
     */
    secondWidth: 0.0888888888889,

    /**
     * Seconds from midnight to 5AM (60 * 60 * 5)
     */
    startTimeFromMidnight: 18000,

    /**
     * Seconds in a full day (60 * 60 * 24)
     */
    secondsInFullDay: 86400,
} as const;
